import PropTypes from "prop-types";

import logo from "../../../assets/img/property-overview-PIC-01.png";
import useWindowSize from "../../../hooks/useWindowSize";

const propTypes = { imageUrl: PropTypes.string };

const defaultProps = { imageUrl: "" };

function PropertyImage({ imageUrl }) {
  const window = useWindowSize();
  const propertyImageBgSize = imageUrl ? "cover" : "contain";
  const propertyImageUrl = imageUrl || logo;

  return (
    <div
      style={{
        backgroundImage: `url(${propertyImageUrl})`,
        backgroundSize: propertyImageBgSize,
      }}
      className={`property-image ${
        window?.width < 991 ? "property-image--blured-bottom" : ""
      }`}
    >
      &nbsp;
    </div>
  );
}

PropertyImage.propTypes = propTypes;
PropertyImage.defaultProps = defaultProps;

export default PropertyImage;
